var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "2 1 20 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.807 6.16a5.596 5.596 0 0 1-2.956-1.663 5.211 5.211 0 0 1-1.37-3.013V1h-3.958v15.041c0 .668-.218 1.319-.624 1.86a3.31 3.31 0 0 1-1.64 1.16 3.45 3.45 0 0 1-2.037.02 3.318 3.318 0 0 1-1.666-1.125 3.068 3.068 0 0 1-.33-3.343 3.234 3.234 0 0 1 1.228-1.29 3.423 3.423 0 0 1 1.753-.473c.342-.001.682.047 1.01.143v-3.85a8.178 8.178 0 0 0-1.148-.056 7.475 7.475 0 0 0-3.944 1.239 7.027 7.027 0 0 0-2.592 3.106 6.7 6.7 0 0 0-.397 3.961 6.876 6.876 0 0 0 1.93 3.523 7.37 7.37 0 0 0 3.719 1.94A7.55 7.55 0 0 0 12 22.483a7.223 7.223 0 0 0 3.285-2.56 6.776 6.776 0 0 0 1.242-3.882V8.34A9.64 9.64 0 0 0 22 10.012V6.27a5.795 5.795 0 0 1-1.147-.11h-.046Z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.dc51fa36aea5d9e283392a1c6f5d492d.svg";
export { ForwardRef as ReactComponent };